import { render, staticRenderFns } from "./MonthHistory.vue?vue&type=template&id=53bcb652&scoped=true&"
import script from "./MonthHistory.vue?vue&type=script&lang=js&"
export * from "./MonthHistory.vue?vue&type=script&lang=js&"
import style0 from "./MonthHistory.vue?vue&type=style&index=0&id=53bcb652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bcb652",
  null
  
)

export default component.exports